import { memo } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, BoxProps, Toolbar } from '@mui/material';
// config
import { HEADER } from '../../../config-global';
// utils
import { bgBlur } from '../../../utils/cssStyles';
// components
import { NavListProps, NavSectionHorizontal } from '../../../components/nav-section';
//
import { createNavConfig } from './config-navigation';
import { useGetConfigurationQuery } from '../../../redux/slices/apiSlice';
import { useAuthContext } from '../../../auth/useAuthContext';

// ----------------------------------------------------------------------

function NavHorizontal() {
  const theme = useTheme();
  const { data, isSuccess, error } = useGetConfigurationQuery();
  const { user } = useAuthContext();
  let localNavConfig: {
    subheader: string;
    items: NavListProps[];
  }[] = [];

  if (isSuccess) {
    console.log(`### configuration: ${JSON.stringify(data)}`);
    if (data) {
      localNavConfig = createNavConfig(data, user);
    }
  } else {
    console.log(`### Error loading configuration: ${error}`);
  }
  return (
    <AppBar
      component="nav"
      color="transparent"
      sx={{
        boxShadow: 0,
        top: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
      }}
    >
      <Toolbar
        sx={{
          ...bgBlur({
            color: theme.palette.background.default,
          }),
        }}
      >
        <NavSectionHorizontal sx={{ textTransform: 'none' }} data={localNavConfig} />
      </Toolbar>

      <Shadow />
    </AppBar>
  );
}

export default memo(NavHorizontal);

// ----------------------------------------------------------------------

function Shadow({ sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        width: 1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
